import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query-v5';
import { useUserSetupStore } from '@sib/auth';
import api from '../api';
import { OrganizationDto, YourTeamDto } from '../api-client';
import { BillingContactProvider, QueryKey } from '../enums';

export const useGetOrganization = (
  organizationId?: string,
  options?: UseQueryOptions<OrganizationDto>
): UseQueryResult<OrganizationDto> => {
  const { setUserPermissions } = useUserSetupStore();

  return useQuery({
    enabled: !!organizationId,
    queryKey: [QueryKey.Resource.Organization, organizationId],
    queryFn: async () => {
      const data =
        await api.organization.organizationControllerGetOrganizationById(
          organizationId || ''
        );

      setUserPermissions(data.userPermissions || []);

      return data;
    },
    ...options,
  });
};

interface UseGetYourTeamPayload {
  organizationId?: string;
  isVectorOrganization: boolean | null;
}

export const useGetYourTeam = (
  { organizationId, isVectorOrganization }: UseGetYourTeamPayload,
  options?: UseQueryOptions<YourTeamDto>
): UseQueryResult<YourTeamDto> =>
  useQuery({
    enabled: !!organizationId && typeof isVectorOrganization === 'boolean',
    queryKey: [QueryKey.Resource.OrganizationYourTeam, organizationId],
    queryFn: async () => {
      const data = await api.organization.organizationControllerGetYourTeam(
        organizationId || '',
        {
          billingContactProvider: isVectorOrganization
            ? BillingContactProvider.Vector
            : BillingContactProvider.Sib,
        }
      );

      return data;
    },
    ...options,
  });
